import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";
import { useSelector } from "react-redux";

export const RESET_STATE_KELAS_KAMAR = {
  id: "",
  name: "",
  remark: "-",
  id_kelaskunjungan: "",
  name_kelaskunjungan: "",
};

export const getAllKelasKamar = async (url = "/bed/listkelaskamar") => {
  try {
    const api = await instance2.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteKelasKamarById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      "/bed/deletekelaskamar",
      {},
      {
        headers: {
          idkelaskamar: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData({
      id: "",
      name: "",
      code: "",
    });
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name_kelaskunjungan",
    disablePadding: false,
    label: "KELAS KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, run, formData, setFormData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addKelasKamar = async () => {
    return instance2.post("/bed/addkelaskamar", {
      ...formData,
    });
  };

  const updateKelasKamar = () => {
    // console.log(formData);
    return instance2.post(
      "/bed/updatekelaskamar",
      {
        ...formData,
      },
      {
        headers: {
          idkelaskamar: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addKelasKamar();
        } else if (formData.id !== "") {
          await updateKelasKamar();
        }
        run(!run);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const master = useSelector(({ master }) => master);

  const kelasKunjungan = master.kelas_kunjungan.list_select;
  // console.log(kelasKunjungan, "kelaskunjungan");

  return (
    <Modal title={`${titleModal(formData.id)} Kelas Kamar`} show={setShowModal}>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name="name"
              label="Nama"
              id="name"
              autoFocus={true}
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Nama"
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="remark"
              label="Remark"
              id="remark"
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder="Remark"
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name="id_kelaskunjungan"
              label="Kelas Kunjungan"
              id="id_kelaskunjungan"
              withSearch={false}
              data={kelasKunjungan}
              value={formData.id_kelaskunjungan}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  id_kelaskunjungan: e.target.value,
                  name_kelaskunjungan: e.target.label,
                });
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
};
